import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import SHA256 from 'crypto-js/sha256';
import 'react-quill/dist/quill.snow.css';
import './BoardDetailContent.css';

const BoardDetailContent = ({ id }) => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const isAdmin = searchParams.get('admin') === 'true';

    // 상태 관리
    const [boardData, setBoardData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // 게시글 데이터 불러오기
    useEffect(() => {
        const fetchBoardDetail = async () => {
            try {
                setLoading(true);
                setError(null);

                // API 호출
                const response = await fetch(`https://mrlo.co.kr/api/get-post.php?id=${id}`);
                const result = await response.json();

                if (result.success) {
                    setBoardData(result.data);
                } else {
                    setError(result.message || '게시글을 불러오는데 실패했습니다.');
                }
            } catch (err) {
                setError('서버와 통신 중 오류가 발생했습니다.');
                console.error('Error fetching board detail:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchBoardDetail();
    }, [id]);

    const handleListClick = () => {
        // admin 파라미터 유지
        const adminParam = isAdmin ? '?admin=true' : '';
        navigate(`/board${adminParam}`);
    };

    const handleDeleteClick = async () => {
        const password = prompt('비밀번호를 입력하세요:');

        if (password === null) {
            // 취소 버튼 클릭 시
            return;
        }

        try {
            // 비밀번호 SHA256 해싱
            const hashedPassword = SHA256(password).toString();

            // API로 삭제 요청
            const response = await fetch('https://mrlo.co.kr/api/delete-post.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ id, password: hashedPassword })
            });

            const result = await response.json();

            if (result.success) {
                // 삭제 성공
                alert('삭제되었습니다.');
                navigate('/board?admin=true');
            } else {
                // 삭제 실패
                alert(result.message || '삭제에 실패했습니다.');
            }
        } catch (err) {
            alert('서버와 통신 중 오류가 발생했습니다.');
            console.error('Error deleting post:', err);
        }
    };

    // 로딩 중일 때
    if (loading) {
        return (
            <div className="board-detail-wrapper">
                <div style={{ textAlign: 'center', padding: '50px 0', color: '#666' }}>
                    로딩 중...
                </div>
            </div>
        );
    }

    // 에러 발생 시
    if (error) {
        return (
            <div className="board-detail-wrapper">
                <div style={{ textAlign: 'center', padding: '50px 0', color: '#ff0000' }}>
                    {error}
                </div>
                <div className="board-detail-buttons" style={{marginBottom:"50px"}}>
                    <button className="btn-list" onClick={handleListClick}>
                        목록으로
                    </button>
                </div>
            </div>
        );
    }

    // 데이터가 없을 때
    if (!boardData) {
        return (
            <div className="board-detail-wrapper">
                <div style={{ textAlign: 'center', padding: '50px 0', color: '#666' }}>
                    게시글을 찾을 수 없습니다.
                </div>
                <div className="board-detail-buttons" style={{marginBottom:"50px"}}>
                    <button className="btn-list" onClick={handleListClick}>
                        목록으로
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="board-detail-wrapper">
            <div className="board-detail-header">
                <h2 className="board-detail-title">{boardData.title}</h2>
                <div className="board-detail-info">
                    <span className="info-item">{boardData.created_at}</span>
                </div>
            </div>

            <div
                className="board-detail-content ql-editor"
                dangerouslySetInnerHTML={{
                    __html: boardData.content
                        .replace(/&lt;/g, '<')
                        .replace(/&gt;/g, '>')
                        .replace(/&amp;/g, '&')
                        .replace(/&quot;/g, '"')
                        .replace(/&#039;/g, "'")
                }}
            />

            <div className="board-detail-buttons" style={{marginBottom:"50px"}}>
                <button className="btn-list" onClick={handleListClick}>
                    목록으로
                </button>
                {isAdmin && (
                    <button className="btn-delete" onClick={handleDeleteClick}>
                        삭제하기
                    </button>
                )}
            </div>
        </div>
    );
};

export default BoardDetailContent;
